/* eslint-disable no-restricted-syntax, guard-for-in, no-mixed-operators, react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars, no-unsafe-optional-chaining, react/no-array-index-key, react/button-has-type */

import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { useDispatch, useSelector } from 'react-redux';

import { showLogin } from '../../redux/slices/authSlice/actions';
import { fetchTestseries, registerTest } from '../../redux/slices/fixedMockSlice';

import RegisterMockTestModalComponent from '../MockTest/RegisterModal';
import ActionButton from './ActionButton';
import TestseriseMobile from './TestseriseMobile';
import TimeStatus from './TimeStatus';

import { javaApi } from '../../utils/AxiosInstance';
import { formatDate } from '../../utils/helper';

import cardsimage from '../../assets/images/fixed-mock/cardsimages.png';
import LiveIcon from '../../assets/images/live-icon.svg';

import styles from '../../styles/timebase-testseries.module.scss';

function TestseriseCard({ handleViewAll }) {
  const [getalltest, setalltest] = useState([]);
  const [queryparms, setquryprams] = useState({ page: 1 });
  const [pagenumber, setpagenumber] = useState(0);
  const [totalpage, settotalpage] = useState(null);
  const [blinkicon, setblinkicon] = useState(true);
  const [modalView, setModalView] = React.useState(null);
  const dispatch = useDispatch();
  const [testInfoData, setTestInfoData] = useState(null);
  const [isRegisteredFlag, setisRegisteredFlag] = useState(false);
  const [renderFlag, setRenderFlag] = useState(false);
  const [viewMoreFlag, setViewMoreFlag] = useState(false);
  const [refreshDataFlag, setRefreshDataFlag] = useState(false);

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const authUserEmail = useSelector((state) => state.auth?.authUser?.email);
  const testseries = useSelector((state) => state.fixedMock.testseries);

  React.useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchTestseries(queryparms));
    }
  }, [dispatch, queryparms, isAuthenticated]);

  useEffect(() => {
    if ((testseries && !isRegisteredFlag) || viewMoreFlag) {
      if (pagenumber < totalpage) {
        if (testseries?.data) {
          // eslint-disable-next-line no-unsafe-optional-chaining
          if (getalltest[0]?.mappingId === testseries?.data?.beans[0].mappingId) {
            setalltest(testseries?.data?.beans);
            setpagenumber(testseries?.data?.currentPageNo);
            settotalpage(testseries?.data?.totalPages);
          } else {
            setalltest([...getalltest, ...testseries?.data?.beans]);
            setpagenumber(testseries?.data?.currentPageNo);
            settotalpage(testseries?.data?.totalPages);
          }
        } else {
          setalltest([]);
        }
      } else if (pagenumber === 0) {
        if (testseries?.data) {
          setalltest(testseries?.data?.beans);
          setpagenumber(testseries?.data?.currentPageNo);
          settotalpage(testseries?.data?.totalPages);
        } else {
          setalltest([]);
        }
      }
    } else if (testseries?.data) {
      setalltest(testseries?.data?.beans);
      setpagenumber(testseries?.data?.currentPageNo);
      settotalpage(testseries?.data?.totalPages);
    }
    setViewMoreFlag(false);
    setRenderFlag(!renderFlag);
  }, [testseries]);

  const handlepagination = () => {
    setViewMoreFlag(true);
    if (pagenumber < totalpage) {
      setquryprams({
        ...queryparms,
        // eslint-disable-next-line no-unsafe-optional-chaining
        page: queryparms.page + 1,
      });
    }
  };

  useEffect(() => {
    window.setTimeout(() => setblinkicon(!blinkicon), 1000);
  }, [blinkicon]);

  const handleRegister = React.useCallback(
    (item) => async (event) => {
      event.preventDefault();
      setTestInfoData(item);
      let testWindow = null;
      if (!isAuthenticated) {
        dispatch(showLogin());
      } else if (item?.userTestStatus === 'START_NOW' || item?.userTestStatus === 'INCOMPLETE') {
        testWindow = window.open(
          `/test-series/${item?.courseId || 1}/${item.mappingId}/`,
          '_blank',
          'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no',
        );
      } else if (item?.userTestStatus === 'COMPLETED') {
        testWindow = window.open(
          `/test-series/${item?.courseId}/${item?.mappingId}/result`,
          '_blank',
          'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no',
        );
      } else if (authUserEmail) {
        const res = await dispatch(registerTest(item));
        if (res) {
          dispatch(fetchTestseries({ page: 1 }));
          setisRegisteredFlag(true);
        }
      } else {
        setModalView('EMAIL');
      }

      const interval = setInterval(async () => {
        if (testWindow && testWindow.closed) {
          const response = await javaApi.post('app-test-series-ws/api/v1/test-series/fixedmock/list', { page: 1 });
          if (response?.data?.success) {
            // eslint-disable-next-line no-unsafe-optional-chaining
            if (getalltest[0]?.mappingId !== response?.data?.data?.beans[0]?.mappingId) {
              setalltest(response?.data?.data?.beans);
            } else {
              setalltest(response?.data?.data?.beans);
            }
            setquryprams({
              ...queryparms,
              // eslint-disable-next-line no-unsafe-optional-chaining
              page: 1,
            });
            setpagenumber(1);
          } else {
            setalltest([]);
          }

          window.clearInterval(interval);
        }
      }, 500);

      return () => window.clearInterval(interval);
    },
    [isAuthenticated, authUserEmail, dispatch, queryparms, getalltest],
  );
  const handleShowLogin = () => {
    dispatch(showLogin());
  };
  useEffect(() => {
    if (refreshDataFlag) {
      dispatch(fetchTestseries({ page: 1 }));
      setRefreshDataFlag(false);
    }
  }, [refreshDataFlag]);

  const getDataFlag = (data, device) => {
    if (data) {
      setRefreshDataFlag(data);
    }
  };

  return (
    <>
      {isAuthenticated ? (
        <div className={`${styles.cardcontentwrapper}`}>
          {getalltest?.map((item) => (
            <div className={`${styles.cardwarpper}`} key={item?.id}>
              <div className={`${styles.cardwarpper}`}>
                <div className={`${styles.card}`}>
                  <div>
                    <div className={styles.title_wrapper}>
                      <span className={styles.title_Freetab}>
                        <b>Free</b>
                      </span>
                      <span className={styles.title}>
                        <b>{item?.examId}</b>
                      </span>
                    </div>
                    <div className={`${styles.contetentwrapper}`}>
                      <span className={styles.subheading}>{item?.title}</span>
                    </div>
                    <div className={styles.actionwrapper}>
                      <span className={styles?.conut}>
                        {item?.userTestStatus === 'COMPLETED' ? (
                          <>
                            Result On {formatDate(item?.resultTime, 'ddd MMM')}
                            {formatDate(item?.resultTime, 'hh:mm aaa')}
                          </>
                        ) : (
                          <>
                            {`${item?.questionCount} Qs • ${item?.duration / 60} Mins
                          • ${item?.maxMarks} Marks`}
                          </>
                        )}
                      </span>
                      <ActionButton item={item} handleRegister={handleRegister} />
                    </div>
                  </div>
                </div>
                <div className={styles.cardfooter}>
                  <TimeStatus item={item} getDataFlag={(data) => getDataFlag(data, 'web')} />
                  <span>
                    <div className={styles.statuslive}>
                      {item?.live && (
                        <>
                          <LiveIcon className={styles.liveIcon} />
                          <span className={styles.livetext}>Live</span>
                        </>
                      )}
                    </div>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={`${styles.logincontentwrapper}`}>
          {[1, 2, 3, 4, 5, 6]?.map((item) => (
            // eslint-disable-next-line react/jsx-key
            <Image height={120} width={120} alt="cards" src={cardsimage} />
          ))}
          <div className={styles.textLoging}>
            <div className={styles.subTextforLogin}>Login to view all our scholarship tests</div>
            <div className={styles.buttonwrapper}>
              <button onClick={handleShowLogin} className={styles.login_button}>
                Login
              </button>
            </div>
          </div>
        </div>
      )}
      {getalltest?.length > 0 && pagenumber < totalpage && (
        <div className={styles.viewmorewrapper}>
          <button type="button" className={styles?.viewmore} onClick={handlepagination}>
            View More
          </button>
        </div>
      )}
      <RegisterMockTestModalComponent mockTest={testInfoData} modalView={modalView} setModalView={setModalView} />
      <TestseriseMobile
        handleRegister={handleRegister}
        getalltest={getalltest}
        blinkicon={blinkicon}
        handleViewAll={handleViewAll}
        handlepagination={handlepagination}
        isAuthenticated={isAuthenticated}
        handleShowLogin={handleShowLogin}
        pagenumber={pagenumber}
        totalpage={totalpage}
        getDataFlag={(data) => {
          getDataFlag(data, 'mweb');
        }}
      />
    </>
  );
}

export default TestseriseCard;
